import { KuxLinkAsAssetType } from '@kaltura-ott/tvpil';
import { container } from 'tsyringe';

import type { DmsStore } from '../dms/dms-store';

import { MediaAsset } from './MediaAsset';

export class LinkAsAsset extends MediaAsset<KuxLinkAsAssetType> {
  get isAdult(): boolean | undefined {
    const dmsStore = container.resolve<DmsStore>('dmsStore');
    return (
      !!this.data.linkItem?.inAppLink &&
      this.data.linkItem?.inAppLink === dmsStore.dms.adultsConfigurations?.menuCategoryReferenceId
    );
  }
}
